import React from 'react';
import ojoIcon from "../../../assets/icons/workIcons/ojoIcon.svg";

function OjoIcon() {
    return ( 
        <img className="tab-icon" src={ojoIcon} alt="ojoIcon.svg"/>
    );
}

export default OjoIcon;